import React from 'react';
import { scrollToTop } from '../../utils/scrollTo';
import { ScrollToTop } from '../Icons';
import styles from './index.module.scss';

function ScrollTopBtn({ className }) {

    return (
        <button onClick={() => scrollToTop(1)} className={`${styles.scrollToTopBtn} ${className}`}>
            <ScrollToTop />
            <small>TOP</small>
        </button>
    );
}

export default ScrollTopBtn;
